export enum PostOrderErrorCodes {
  PRICE_MISMATCH = 'ROS_001',
}

export type PostOrderErrorResponse = {
  error_message: string;
  error_code: PostOrderErrorCodes;
};